import {
    LICENCE_CATEGORY,
    BASED_LAND_FIXED_STATION_INFORMATION,
    ADDRESS,
    LATITUDE,
    LONGITUDE,
    VENDOR_INFORMATION,
    VENDOR_ADDRESS,
    RADIO_EQUIPMENT_INFORMATION,
    ANTENNA_INFORMATION,
    ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
    FILTER_INFORMATION,
    FEEDER_INFORMATION,
    FREQUENCY_AND_EMISSION_CLASS_INFORMATION,
    SUPPORTING_DOCUMENTS
} from '../../../../common/application.const/Licence/MyLicence/PMNLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatPMN = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfoList = [];
    let stationList = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfoList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => ({
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-call-sign-optional`]: value?.callSign ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-location-of-station`]: value?.locationOfStationEGRooftop ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-station-name`]: value?.stationName ?? '-',
            [`${ADDRESS}-building-name`]: value?.stationAddress?.buildingName ?? '-',
            [`${ADDRESS}-postal-code`]: value?.stationAddress?.postalCode ?? '-',
            [`${ADDRESS}-street-name`]: value?.stationAddress?.streetName ?? '-',
            [`${ADDRESS}-block-house-no`]: value?.stationAddress?.blockNo ?? '-',
            [`${ADDRESS}-unit-optional`]: value?.stationAddress?.unit ?? '-',
            [`${ADDRESS}-floor-level-optional`]: value?.stationAddress?.floor ?? '-',
            [`${LATITUDE}-latitude-degrees`]: value?.latitudeDegrees ?? '-',
            [`${LATITUDE}-latitude-minutes`]: value?.latitudeMinutes ?? '-',
            [`${LATITUDE}-latitude-seconds`]: value?.latitudeSeconds ?? '-',
            [`${LONGITUDE}-longitude-degrees`]: value?.longitudeDegrees ?? '-',
            [`${LONGITUDE}-longitude-minutes`]: value?.longitudeMinutes ?? '-',
            [`${LONGITUDE}-longitude-seconds`]: value?.longitudeSeconds ?? '-',
            [`${LONGITUDE}-building-height-m`]: value?.buildingHeightM ?? '-',
            [`${LONGITUDE}-antenna-effective-height-m`]: value?.stationAntennaEffectiveHeightMAboveGroundLevel ?? '-',
            [`${LONGITUDE}-radius-of-operation`]: value?.radiusOfOperationKm ?? '-',
            [`${LONGITUDE}-antenna-elevation-angle`]: value?.stationElevationAngle ?? '-',
            [`${LONGITUDE}-transportable-optional`]: value?.transportable ?? '-',
            [`${VENDOR_INFORMATION}-vendor-name-optional`]: value?.vendorName ?? '-',
            [`${VENDOR_INFORMATION}-vendor-licence-number-optional`]: value?.vendorLicenceNumber ?? '-',
            [`${VENDOR_INFORMATION}-contact-person-optional`]: value?.contactPerson ?? '-',
            [`${VENDOR_INFORMATION}-contact-number-optional`]: value?.ContactNumber ?? '-',
            [`${VENDOR_ADDRESS}-building-name`]: value?.vendorAddress?.buildingName ?? '-',
            [`${VENDOR_ADDRESS}-postal-code`]: value?.vendorAddress?.postalCode ?? '-',
            [`${VENDOR_ADDRESS}-street-name`]: value?.vendorAddress?.streetName ?? '-',
            [`${VENDOR_ADDRESS}-block-house-no`]: value?.vendorAddress?.blockNo ?? '-',
            [`${VENDOR_ADDRESS}-unit-optional`]: value?.vendorAddress?.unit ?? '-',
            [`${VENDOR_ADDRESS}-floor-level-optional`]: value?.vendorAddress?.floor ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-transmitter`]: value?.manufacturerTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-receiver`]: value?.manufacturerReceiver ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-transmitter`]: value?.modelTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-receiver`]: value?.modelReceiver ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-output-power`]: value?.outputPowerWTransmitter ?? '-',
            [`${ANTENNA_INFORMATION}-manufacturer`]: value?.antennaManufacturer ?? '-',
            [`${ANTENNA_INFORMATION}-polarization`]: value?.polarization ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-effective-height-m-2`]: value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-elevation-angle-2`]: value?.elevationAngle ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-north-latitude-displacement`]: value?.northLatitudeDisplacement ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-east-longitude-displacement`]: value?.eastLongitudeDisplacement ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-gain-db`]: value?.gainDB ?? '-',
            [`${FILTER_INFORMATION}-manufacturer-2`]: value?.filterManufacturer ?? '-',
            [`${FILTER_INFORMATION}-model`]: value?.model ?? '-',
            [`${FILTER_INFORMATION}-insertion-loss-db`]: value?.insertionLossDB ?? '-',
            [`${FILTER_INFORMATION}-tuned-frequency`]: value?.tunedFrequencyMHz ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-type-transmit`]: value?.feederLineTypeTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-type-receive`]: value?.feederLineTypeReceive ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-m-transmit`]: value?.feederLineLengthMTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-m-receive`]: value?.feederLineLengthMReceive ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-db-transmit`]: value?.feederLineLossDBTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-db-receive`]: value?.feederLineLossDBReceive ?? '-',
            [`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`]:
            (value?.frequencyAndEmissionClassInformation ?? []).map((i: any, index: number) => {
                    return {
                        'id-no': index + 1,
                        'assigned-frequency-mhz-from-tx': i?.assignedFrequencyMHzFromTransmit ?? '-',
                        'assigned-frequency-mhz-to-tx': i?.assignedFrequencyMHzToTransmit ?? '-',
                        'assigned-frequency-mhz-from-rx': i?.assignedFrequencyMHzFromReceive ?? '-',
                        'assigned-frequency-mhz-to-rx': i?.assignedFrequencyMHzToReceive ?? '-',
                        'assigned-bandwidth-khz-tx': i?.AssignedBandwidthTx ?? '-',
                        'assigned-bandwidth-khz-rx': i?.AssignedBandwidthRx ?? '-',
                        'start-time': i?.startTime ?? '-',
                        'stop-time': i?.stopTime ?? '-',
                        'emission-class-transmit': i?.emissionClassTransmit ?? '-',
                        'emission-class-receive': i?.emissionClassReceive ?? '-',
                        'power': i?.Power ?? '-',
                        'power-unit': i?.PowerUnit ?? '-',
                        'frequency-entry-tx': i?.FrequencyEntryTx ?? '-',
                        'frequency-entry-rx': i?.FrequencyEntryRx ?? '-'
                    };
                }) ?? '-'
        }));
    }

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        stationList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => {
            const list = {
                id: index + 1,
                label: value?.stationName
            };

            return list;
        });
    }

    licence = {
        id: 'public-mobile-network',
        formID: 'public-mobile-network',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',
            [`${LICENCE_CATEGORY}-station-name`]: stationList ?? '-',
            [`${LICENCE_CATEGORY}-proposed-use-of-system-equipment`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
            [`${LICENCE_CATEGORY}-remarks-optional`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${BASED_LAND_FIXED_STATION_INFORMATION}-call-sign-optional`]:
                baseLandFixedStationInfoList[0][`${BASED_LAND_FIXED_STATION_INFORMATION}-call-sign-optional`] ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-location-of-station`]:
                baseLandFixedStationInfoList[0][`${BASED_LAND_FIXED_STATION_INFORMATION}-location-of-station`] ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-station-name`]:
                baseLandFixedStationInfoList[0][`${BASED_LAND_FIXED_STATION_INFORMATION}-station-name`] ?? '-',

            [`${ADDRESS}-building-name`]: baseLandFixedStationInfoList[0][`${ADDRESS}-building-name`] ?? '-',
            [`${ADDRESS}-postal-code`]: baseLandFixedStationInfoList[0][`${ADDRESS}-postal-code`] ?? '-',
            [`${ADDRESS}-street-name`]: baseLandFixedStationInfoList[0][`${ADDRESS}-street-name`] ?? '-',
            [`${ADDRESS}-block-house-no`]: baseLandFixedStationInfoList[0][`${ADDRESS}-block-house-no`] ?? '-',
            [`${ADDRESS}-unit-optional`]: baseLandFixedStationInfoList[0][`${ADDRESS}-unit-optional`] ?? '-',
            [`${ADDRESS}-floor-level-optional`]: baseLandFixedStationInfoList[0][`${ADDRESS}-floor-level-optional`] ?? '-',

            [`${LATITUDE}-latitude-degrees`]: baseLandFixedStationInfoList[0][`${LATITUDE}-latitude-degrees`] ?? '-',
            [`${LATITUDE}-latitude-minutes`]: baseLandFixedStationInfoList[0][`${LATITUDE}-latitude-minutes`] ?? '-',
            [`${LATITUDE}-latitude-seconds`]: baseLandFixedStationInfoList[0][`${LATITUDE}-latitude-seconds`] ?? '-',

            [`${LONGITUDE}-longitude-degrees`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-longitude-degrees`] ?? '-',
            [`${LONGITUDE}-longitude-minutes`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-longitude-minutes`] ?? '-',
            [`${LONGITUDE}-longitude-seconds`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-longitude-seconds`] ?? '-',
            [`${LONGITUDE}-building-height-m`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-building-height-m`] ?? '-',
            [`${LONGITUDE}-antenna-effective-height-m`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-antenna-effective-height-m`] ?? '-',
            [`${LONGITUDE}-radius-of-operation`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-radius-of-operation`] ?? '-',
            [`${LONGITUDE}-antenna-elevation-angle`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-antenna-elevation-angle`] ?? '-',
            [`${LONGITUDE}-transportable-optional`]: baseLandFixedStationInfoList[0][`${LONGITUDE}-transportable-optional`] ?? '-',

            [`${VENDOR_INFORMATION}-vendor-name-optional`]:
                baseLandFixedStationInfoList[0][`${VENDOR_INFORMATION}-vendor-name-optional`] ?? '-',
            [`${VENDOR_INFORMATION}-vendor-licence-number-optional`]:
                baseLandFixedStationInfoList[0][`${VENDOR_INFORMATION}-vendor-licence-number-optional`] ?? '-',
            [`${VENDOR_INFORMATION}-contact-person-optional`]:
                baseLandFixedStationInfoList[0][`${VENDOR_INFORMATION}-contact-person-optional`] ?? '-',
            [`${VENDOR_INFORMATION}-contact-number-optional`]:
                baseLandFixedStationInfoList[0][`${VENDOR_INFORMATION}-contact-number-optional`] ?? '-',

            [`${VENDOR_ADDRESS}-building-name`]: baseLandFixedStationInfoList[0][`${VENDOR_ADDRESS}-building-name`] ?? '-',
            [`${VENDOR_ADDRESS}-postal-code`]: baseLandFixedStationInfoList[0][`${VENDOR_ADDRESS}-postal-code`] ?? '-',
            [`${VENDOR_ADDRESS}-street-name`]: baseLandFixedStationInfoList[0][`${VENDOR_ADDRESS}-street-name`] ?? '-',
            [`${VENDOR_ADDRESS}-block-house-no`]: baseLandFixedStationInfoList[0][`${VENDOR_ADDRESS}-block-house-no`] ?? '-',
            [`${VENDOR_ADDRESS}-unit-optional`]: baseLandFixedStationInfoList[0][`${VENDOR_ADDRESS}-unit-optional`] ?? '-',
            [`${VENDOR_ADDRESS}-floor-level-optional`]: baseLandFixedStationInfoList[0][`${VENDOR_ADDRESS}-floor-level-optional`] ?? '-',

            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-transmitter`]:
                baseLandFixedStationInfoList[0][`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-transmitter`] ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-receiver`]:
                baseLandFixedStationInfoList[0][`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-receiver`] ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-transmitter`]:
                baseLandFixedStationInfoList[0][`${RADIO_EQUIPMENT_INFORMATION}-model-transmitter`] ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-receiver`]:
                baseLandFixedStationInfoList[0][`${RADIO_EQUIPMENT_INFORMATION}-model-receiver`] ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-output-power`]:
                baseLandFixedStationInfoList[0][`${RADIO_EQUIPMENT_INFORMATION}-output-power`] ?? '-',

            [`${ANTENNA_INFORMATION}-manufacturer`]: baseLandFixedStationInfoList[0][`${ANTENNA_INFORMATION}-manufacturer`] ?? '-',
            [`${ANTENNA_INFORMATION}-polarization`]: baseLandFixedStationInfoList[0][`${ANTENNA_INFORMATION}-polarization`] ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-effective-height-m-2`]:
                baseLandFixedStationInfoList[0][`${ANTENNA_INFORMATION}-antenna-effective-height-m-2`] ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-elevation-angle-2`]:
                baseLandFixedStationInfoList[0][`${ANTENNA_INFORMATION}-antenna-elevation-angle-2`] ?? '-',

            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-north-latitude-displacement`]:
                baseLandFixedStationInfoList[0][`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-north-latitude-displacement`] ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-east-longitude-displacement`]:
                baseLandFixedStationInfoList[0][`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-east-longitude-displacement`] ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-gain-db`]:
                baseLandFixedStationInfoList[0][`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-gain-db`] ?? '-',

            [`${FILTER_INFORMATION}-manufacturer-2`]: baseLandFixedStationInfoList[0][`${FILTER_INFORMATION}-manufacturer-2`] ?? '-',
            [`${FILTER_INFORMATION}-model`]: baseLandFixedStationInfoList[0][`${FILTER_INFORMATION}-model`] ?? '',
            [`${FILTER_INFORMATION}-insertion-loss-db`]: baseLandFixedStationInfoList[0][`${FILTER_INFORMATION}-insertion-loss-db`] ?? '-',
            [`${FILTER_INFORMATION}-tuned-frequency`]: baseLandFixedStationInfoList[0][`${FILTER_INFORMATION}-tuned-frequency`] ?? '-',

            [`${FEEDER_INFORMATION}-feeder-line-type-transmit`]:
                baseLandFixedStationInfoList[0][`${FEEDER_INFORMATION}-feeder-line-type-transmit`] ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-type-receive`]:
                baseLandFixedStationInfoList[0][`${FEEDER_INFORMATION}-feeder-line-type-receive`] ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-m-transmit`]:
                baseLandFixedStationInfoList[0][`${FEEDER_INFORMATION}-feeder-line-length-m-transmit`] ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-m-receive`]:
                baseLandFixedStationInfoList[0][`${FEEDER_INFORMATION}-feeder-line-length-m-receive`] ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-db-transmit`]:
                baseLandFixedStationInfoList[0][`${FEEDER_INFORMATION}-feeder-line-loss-db-transmit`] ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-db-receive`]:
                baseLandFixedStationInfoList[0][`${FEEDER_INFORMATION}-feeder-line-loss-db-receive`] ?? '-',

            [`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`]:
                baseLandFixedStationInfoList[0][`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`] ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-list`]: baseLandFixedStationInfoList ?? [...baseLandFixedStationInfoList],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const pmnPayload = {
    formatPMN
};

export default pmnPayload;
